import { getPillarDisplayName } from '../constants/awardCategoryPillar';
import { apiRequest } from './apiConfig';
import vistaService from './vistaService';

/**
 * Submits an award application to the CMS.
 *
 * @param {object} submissionData - The submission data to be sent.
 * @returns {Promise<object>} The response from the API.
 */
export const submitAwardApplication = async (
  submissionData: Record<string, any>
): Promise<any> => {
  const response = await apiRequest('/award-submissions', {
    method: 'POST',
    body: JSON.stringify({ data: submissionData }),
  });

  const result = await response.json();
  return result;
};

export const getSubmissionStatistics = async (): Promise<any> => {
  const response = await apiRequest('/award-submissions/aggregate', {
    method: 'GET',
  });

  const result = await response.json();

  // Transform pillar names to display names
  if (result.data && Array.isArray(result.data)) {
    result.data = result.data.map((item: any) => ({
      ...item,
      pillar: getPillarDisplayName(item.pillar),
    }));
  }

  return result;
};

export const updateAwardApplication = async (
  documentId: string,
  submissionData: Record<string, any>
): Promise<any> => {
  return vistaService.updateAwardSubmission(documentId, submissionData);
};
